export const serverUrl = process.env.NODE_ENV === 'production'
  ? 'https://www.51mydoor.com'
  : 'https://www.51mydoor.com'

export const serverApi = `${serverUrl}/mendaoVoluntary`

export const bannerTypes = {
  home: 1,       // 首页
  policy: 2,     // 政策资讯
  speciality: 3, // 专业解读
  school: 4,     // 院校介绍
}

// school-院校层级
export const schoolCollegeLevel = [
  { value: '1', label: '双一流', },
  { value: '2', label: '中央直管', },
  { value: '3', label: '985', },
  { value: '4', label: '211', },
  { value: '5', label: '双高计划', },
  { value: '6', label: '国家示范(骨干)', },
]
// qualifications-博硕资格
export const schoolQualifications = [
  { value: '1', label: '硕士点', },
  { value: '2', label: '博士点', },
  { value: '3', label: '研究生院', },
  { value: '4', label: '自划线', },
  { value: '5', label: '推免资格', }
]

// 院校类型
export const schoolTypes = [
  { label: '不限', value: '不限' }, { label: '综合', value: '综合' }, { label: '工科', value: '工科' }, { label: '财经', value: '财经' }, { label: '农业', value: '农业' }, { label: '林业', value: '林业' },
  { label: '医药', value: '医药' }, { label: '师范', value: '师范' }, { label: '体育', value: '体育' }, { label: '政法', value: '政法' }, { label: '民族', value: '民族' },
  { label: '语言', value: '语言' }, { label: '艺术', value: '艺术' }, { label: '其他', value: '其他' }
]

// 办学性质
export const schoolNatureList = [
  { label: '公办', value: '1' },
  { label: '民办', value: '2' },
  { label: '合办', value: '3' }
]

// student
export const studentSubject = [
  { value: 1, label: '理科', },
  { value: 2, label: '文科', },
  { value: 3, label: '艺术理', },
  { value: 4, label: '艺术文', },
]

// 国内所有省
export const provinces = [
  { label: '不限', value: '不限' }, { label: '陕西', value: '陕西省' }, { label: '安徽', value: '安徽省' }, { label: '北京', value: '北京市' }, { label: '重庆', value: '重庆市' },
  { label: '福建', value: '福建省' }, { label: '广东', value: '广东省' }, { label: '广西', value: '广西' }, { label: '甘肃', value: '甘肃省' }, { label: '贵州', value: '贵州省' },
  { label: '河北', value: '河北省' }, { label: '河南', value: '河南省' }, { label: '海南', value: '海南省' }, { label: '湖北', value: '湖北省' }, { label: '湖南', value: '湖南省' },
  { label: '黑龙江', value: '黑龙江省' }, { label: '吉林', value: '吉林省' }, { label: '江苏', value: '江苏省' }, { label: '江西', value: '江西省' }, { label: '辽宁', value: '辽宁省' },
  { label: '内蒙古', value: '内蒙古' }, { label: '宁夏', value: '宁夏' }, { label: '青海', value: '青海省' }, { label: '上海', value: '上海市' },
  { label: '四川', value: '四川省' }, { label: '山东', value: '山东省' }, { label: '山西', value: '山西省' }, { label: '天津', value: '天津市' }, { label: '西藏', value: '西藏' },
  { label: '新疆', value: '新疆' }, { label: '云南', value: '云南省' }, { label: '浙江', value: '浙江省' }, { label: '其他', value: '其他' }
]

export const secondarilySubjects = [
  { label: '化学', value: '化学' },
  { label: '生物', value: '生物' },
  { label: '政治', value: '政治' },
  { label: '地理', value: '地理' },
]
